import { cn } from "@devhop/ui";
import { useCartAddPulse } from "../hooks/useCartAddPulse";
import { CartContent } from "./CartContent";

export function CartPanel() {
  const isPulsing = useCartAddPulse();

  return (
    <div
      className={cn(
        "flex h-full flex-col border-l bg-card",
        isPulsing && "animate-cart-panel-flash",
      )}
    >
      <CartContent />
    </div>
  );
}
